import type { Sdk } from '@OnArk/sdk';
import { isInternalPath } from '@onark/shared/internalPath';

/**
 * Ask for a sign-in link that lands on `to` afterward. Falls back to the plain
 * request if the api refuses the destination one, which is what an api build
 * older than the `to` argument does: signing in matters more than where it
 * lands.
 */
export async function requestSignInLink(
  client: Pick<Sdk, 'requestMagicLink' | 'requestMagicLinkTo'>,
  email: string,
  to: unknown
): Promise<void> {
  if (isInternalPath(to)) {
    try {
      await client.requestMagicLinkTo({ email, to });

      return;
    } catch {
      // fall through to the request every api build understands
    }
  }

  await client.requestMagicLink({ email });
}
